import { Helmet } from "react-helmet-async";

const SITE_URL = "https://tikhemaanshot.nl";
// Real brand hero image — Emergent CDN, 1200+px wide, satisfies OG minimum 600x315 (recommended 1200x630).
const DEFAULT_OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/91b039dc-51e4-4e53-aaae-68155d45e4bb/images/a0067dc0bd562b6806aa88afb54de5c878fdc2029fb5757d6f6fb7a1449dd1d7.jpeg";

/**
 * Reusable SEO component. Sets <title>, meta description, canonical, and Open Graph tags.
 * `path` should start with a `/` (e.g. "/zakelijk").
 */
const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} — Tik Hem Aan!`
    : "Tik Hem Aan! — Nederlandse shot brand uit Assen";
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Tik Hem Aan!" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Tik Hem Aan! — Nederlandse premium shots" />
      <meta property="og:locale" content="nl_NL" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
